import { Grid } from '@mui/material';
import { getDay, getMonth, parseSecondsToString } from '@nx-smartmonkey/shared/helpers';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { Language } from '@nx-smartmonkey/shared/domain';
import { Route } from '../../../../../domain/route/Route';
import { useRetrieveActiveLanguage } from '../../../../../hooks/translations/useRetrieveActiveLanguage';
import { Text } from '../../../../../react-components/Text';
import { ItemsSeparator } from '../../../components/ItemsSeparator';
import { useRetrieveVehicle } from '../../../hooks/useRetrieveVehicle';
import { RouteLabel } from './RouteLabel';

type NotStartedProps = {
  selectedRoute: Route;
};

export const NotStarted = ({ selectedRoute }: NotStartedProps) => {
  const { activeLanguage } = useRetrieveActiveLanguage();
  const { data: vehicleData } = useRetrieveVehicle();

  const language = activeLanguage ?? Language.getDefaultLanguage().value;

  if (!vehicleData) {
    return null;
  }

  const hasStops = selectedRoute.stops.length > 0;

  return (
    <Grid container direction="column" gap="6px">
      <RouteLabel selectedRoute={selectedRoute} />

      <Grid container direction="row" gap="8px" alignItems="center">
        <Text variant="body" style={{ color: RoutalPalette.secondary00 }}>
          {`${getDay({
            date: selectedRoute.plan_execution_date,
            language,
          })}  ${getMonth({
            date: selectedRoute.plan_execution_date,
            language,
          })}`}
        </Text>
        {hasStops && (
          <>
            <ItemsSeparator />
            <Text variant="body" style={{ color: RoutalPalette.secondary00 }}>
              {selectedRoute.planned_end_time !== undefined && selectedRoute.planned_start_time !== undefined
                ? `${parseSecondsToString(selectedRoute.planned_end_time - selectedRoute.planned_start_time)}`
                : `00h 00m`}
            </Text>
          </>
        )}
        <ItemsSeparator />
        <Text
          variant="body"
          style={{ color: RoutalPalette.secondary00 }}
          intlId="drivers.route_header.num_stops"
          intlValues={{ num: selectedRoute.stops.length }}
        />
        {hasStops && (
          <>
            <ItemsSeparator />
            <Text variant="body" style={{ color: RoutalPalette.secondary00 }}>
              {`${selectedRoute.getTotalDistance(vehicleData.project.units.distance).toString()}${
                vehicleData.project.units.distance
              }`}
            </Text>
          </>
        )}
      </Grid>
    </Grid>
  );
};
